import type { OMSConfig, StrategyEvaluator, SignalResult, StrategyContext } from '../types';
import { getConnectingDotsRows, getSortKey } from './shared';
import { ensureFlatOpts } from '../../analysis/trend-evaluator';
import { extractSnapshotOptions } from '../../../lib/snapshot-search';

export const evaluateConnectingDotsItmFirst: StrategyEvaluator = (data: any, currentUnixTime: number, config: OMSConfig, context: StrategyContext): SignalResult | null => {
    if (!data) return null;

    const { symbol, expiry, activeRange, gap, settingsMode } = context;
    const spot = data.spotPrice || 0;
    if (spot <= 0) return null;
    
    const atmStrike = Math.round(spot / gap) * gap;

    const { itmRows } = getConnectingDotsRows(data, symbol, expiry, atmStrike, activeRange, gap);
    itmRows.sort((a: any, b: any) => getSortKey(b, settingsMode) - getSortKey(a, settingsMode));

    const top1Itm = itmRows[0];
    
    if (top1Itm && (top1Itm.volume > 0 || top1Itm.oi > 0)) {
        const status = top1Itm.type === 'CE' ? 'BULL' : 'BEAR';
        const entryStrike = top1Itm.strike;
        
        const liveRawOptsArr = context.chain || extractSnapshotOptions(data, symbol, expiry) || [];
        const liveFlatOpts = ensureFlatOpts(liveRawOptsArr);

        let entryPrice = 0;
        const atmRow = liveFlatOpts.find(r => r.strike === entryStrike && r.type === top1Itm.type);
        if (atmRow) {
            entryPrice = atmRow.ltp || atmRow.close || atmRow.price || 0;
        }

        if (entryPrice > 0) {
            return {
                trade_type: status,
                strike: entryStrike,
                option_type: status === 'BULL' ? 'CE' : 'PE',
                entry_price: entryPrice,
                remarks: `Top 1 ITM is ${top1Itm.type}`
            };
        }
    }

    return null;
};
